// import axios from 'axios';
// const BASE_URL = '/api/session/current-user';

class ConsultationAttendeesService {
  /**
   * @param sessionId
   * @returns
   */
  static async getAllowedUserIds(sessionId) {
    try {
      console.log(sessionId);
      // const res = await axios.get(`${BASE_URL}/${sessionId}`);
      const res = {
        data: [21, 56],
      };
      return res.data;
    } catch (error) {
      throw error.response;
    }
  }

  /**
   *
   * @param {*} sessionId, userId
   * @returns
   */
  static async setAllowedUserIds(sessionId, userIds) {
    console.log({ sessionId });
    console.log({ userIds });
    return [21, 56];
    // try {
    // const res = await axios.post(
    //   `${BASE_URL}`,
    //   {
    //     id: `${sessionId}`,
    //     user_id: `${userIds}`,
    //   },
    //   {
    //     headers: {
    //       'Content-Type': 'application/json',
    //     },
    //   },
    // );
    // return res.data;
    // } catch (error) {
    //   throw error.response;
    // }
  }
}

export default ConsultationAttendeesService;
